import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const SbuTable = () => {
     const baseUrl = process.env.REACT_APP_BASE_URL;
     const [sbuList, setSbuList] = useState([]);
     const navigate = useNavigate();

     useEffect(() => {
          const token = localStorage.getItem('token');
          fetch(`${baseUrl}/getSbu`, {
               headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
               }
          })
               .then(res => res.json())
               .then(data => {
                    if (data.status) setSbuList(data.data || []);
                    else setSbuList([]);
               });
     }, [baseUrl]);

     return (
          <table className="table">
               <thead>
                    <tr>
                         <th>S.No</th>
                         <th>SBU Name</th>
                         <th>Actions</th>
                    </tr>
               </thead>
               <tbody>
                    {sbuList.map((sbu, idx) => (
                         <tr key={sbu.id}>
                              <td>{idx + 1}</td>
                              <td>{sbu.sbu}</td>
                              <td>
                                   <button className="btn btn-sm btn-primary" onClick={() => navigate(`/sbu/edit/${sbu.id}`)}>
                                        Edit
                                   </button>
                              </td>
                         </tr>
                    ))}
               </tbody>
          </table>
     );
};

export default SbuTable;